import { render, staticRenderFns } from "./PetitionSmsDetails.vue?vue&type=template&id=348a0705&"
import script from "./PetitionSmsDetails.vue?vue&type=script&lang=js&"
export * from "./PetitionSmsDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports